import { axios } from "..";

export type SsoProvider = "google" | "linkedin";

/** Best-effort access log when B2C returns tokens after Google/LinkedIn SSO login. */
export async function logSsoB2cLogin(
  provider: SsoProvider,
  idToken: string,
): Promise<void> {
  try {
    await axios.Post(`/${provider}-sso?action=logB2cLogin`, { idToken });
  } catch {
    // never block login UI
  }
}

/** Best-effort access log for failed B2C SSO attempts (e.g. account not linked). */
export async function logSsoB2cLoginFailed(
  provider: SsoProvider,
  reason: string,
  details?: { email?: string; userId?: string },
): Promise<void> {
  try {
    await axios.Post(`/${provider}-sso?action=logB2cLoginFailed`, {
      reason,
      ...details,
    });
  } catch {
    // never block login UI
  }
}
